export enum SortTypes {
  Unsorted = 'unsorted',
  Alphabetical = 'alphabetical',
  AlphabeticalReversed = 'alphabeticalReversed',
}
